import { User } from '@core/typings/dc-classes';
import { Permissions, Roles } from '@core/typings/dc-enums';

export class PermissionHelper {
    public static permissions: {
        name: string;
        permission: Permissions;
        access: boolean;
        isAdmin: boolean;
        list: {
            name: string;
            permissions: {
                name: string;
                permission: Permissions;
                selected: boolean;
                subs: { name: string; permission: Permissions; selected: boolean }[];
            }[];
        }[];
    } = {
        name: 'Access GDS',
        permission: 'access gds',
        access: false,
        isAdmin: false,
        list: [
            {
                name: 'Dashboards',
                permissions: [
                    {
                        name: 'Main dashboard',
                        permission: 'view main dashboard page',
                        selected: false,
                        subs: [
                            { name: 'View prices', permission: 'view gds prices', selected: false },
                            {
                                name: 'Active Ultimates',
                                permission: 'view total active subscriptions',
                                selected: false,
                            },
                            {
                                name: 'New and active subscriptions per month',
                                permission: 'view active year range subscriptions',
                                selected: false,
                            },
                            {
                                name: 'Live Active Yearly Subscribers',
                                permission: 'view active yearly subscriptions',
                                selected: false,
                            },
                            {
                                name: 'Live Active Monthly Subscribers',
                                permission: 'view active monthly subscriptions',
                                selected: false,
                            },
                            {
                                name: 'Year Overview Yearly',
                                permission: 'view year overview yearly subscriptions',
                                selected: false,
                            },
                            {
                                name: 'Year Overview Monthly',
                                permission: 'view year overview monthly subscriptions',
                                selected: false,
                            },
                            {
                                name: 'Subscription changes',
                                permission: 'view year subscriptions',
                                selected: false,
                            },
                        ],
                    },
                    {
                        name: 'Subscription charts',
                        permission: 'view subscription charts',
                        selected: false,
                        subs: [],
                    },
                ],
            },
            {
                name: 'Management',
                permissions: [
                    { name: 'Cancellations', permission: 'view cancellations page', selected: false, subs: [] },
                    {
                        name: 'Coupon management',
                        permission: 'view any coupon',
                        selected: false,
                        subs: [
                            {
                                name: 'Create coupon',
                                permission: 'create coupon',
                                selected: false,
                            },
                            {
                                name: 'Delete coupon',
                                permission: 'delete coupon',
                                selected: false,
                            },
                        ],
                    },
                    { name: 'CTA management', permission: 'view cta management page', selected: false, subs: [] },
                    {
                        name: 'Financial management',
                        permission: 'view financial management',
                        selected: false,
                        subs: [],
                    },
                    { name: 'Global statistics', permission: 'view any global statistics', selected: false, subs: [] },
                    {
                        name: 'Press releases',
                        permission: 'view press releases page',
                        selected: false,
                        subs: [
                            {
                                name: 'Create press release',
                                permission: 'create press release',
                                selected: false,
                            },
                            {
                                name: 'Update press release',
                                permission: 'update press release',
                                selected: false,
                            },
                            {
                                name: 'Delete press release',
                                permission: 'delete press release',
                                selected: false,
                            },
                        ],
                    },
                    {
                        name: 'Players management',
                        permission: 'view players management page',
                        selected: false,
                        subs: [
                            {
                                name: 'Update user',
                                permission: 'update user',
                                selected: false,
                            },
                            {
                                name: 'Delete user',
                                permission: 'delete user',
                                selected: false,
                            },
                            {
                                name: 'Suspend user',
                                permission: 'suspend user',
                                selected: false,
                            },
                            {
                                name: 'Ban user',
                                permission: 'ban user',
                                selected: false,
                            },
                            {
                                name: 'Unban user',
                                permission: 'unban user',
                                selected: false,
                            },
                            {
                                name: 'Force ultimate user',
                                permission: 'force ultimate user',
                                selected: false,
                            },
                            {
                                name: 'Force reset password',
                                permission: 'force reset password',
                                selected: false,
                            },
                            { name: 'View newsletter opt-ins', permission: 'view newsletter opt ins', selected: false },
                        ],
                    },
                    {
                        name: 'Promotion management',
                        permission: 'view promotion management page',
                        selected: false,
                        subs: [
                            {
                                name: 'Create promotion',
                                permission: 'create promotion',
                                selected: false,
                            },
                            {
                                name: 'Update promotion',
                                permission: 'update promotion',
                                selected: false,
                            },
                            {
                                name: 'Delete promotion',
                                permission: 'delete promotion',
                                selected: false,
                            },
                        ],
                    },
                    {
                        name: 'Reported users',
                        permission: 'view reported users page',
                        selected: false,
                        subs: [
                            {
                                name: 'Update report',
                                permission: 'update reported user',
                                selected: false,
                            },
                            {
                                name: 'Delete report',
                                permission: 'delete reported user',
                                selected: false,
                            },
                        ],
                    },
                    {
                        name: 'Sound management',
                        permission: 'view sound management page',
                        selected: false,
                        subs: [
                            {
                                name: 'Upload name sounds',
                                permission: 'upload name sounds',
                                selected: false,
                            },
                        ],
                    },
                    {
                        name: 'Subscription management',
                        permission: 'view subscription management page',
                        selected: false,
                        subs: [
                            {
                                name: 'Create subscription',
                                permission: 'create subscription',
                                selected: false,
                            },
                            {
                                name: 'Update subscription',
                                permission: 'update subscription',
                                selected: false,
                            },
                            {
                                name: 'Cancel subscription',
                                permission: 'cancel subscription',
                                selected: false,
                            },
                        ],
                    },
                ],
            },
            {
                name: 'Overviews',
                permissions: [
                    { name: 'Financial overview', permission: 'view financial overview', selected: false, subs: [] },
                    {
                        name: 'Payment provider overview page',
                        permission: 'view payment provider overview page',
                        selected: false,
                        subs: [],
                    },
                    {
                        name: 'Promotion overview',
                        permission: 'view promotion overview page',
                        selected: false,
                        subs: [],
                    },
                    {
                        name: 'Year overview',
                        permission: 'view year overview subscriptions',
                        selected: false,
                        subs: [],
                    },
                ],
            },
        ],
    };

    public static hasRole(user: User, role: Roles): boolean {
        let foundRole = false;
        user.roles?.forEach((userRole) => {
            if (userRole.name == role) {
                foundRole = true;
            }
        });
        return foundRole;
    }

    public static hasPermission(user: User, permission: Permissions, checkRolesForPermissions: boolean): boolean {
        let foundPermission = false;
        user.permissions?.forEach((perm) => {
            if (perm.name == permission) {
                foundPermission = true;
            }
        });
        if (checkRolesForPermissions) {
            user.roles?.forEach((role) => {
                role.permissions?.forEach((perm) => {
                    if (perm.name === permission) {
                        foundPermission = true;
                    }
                });
            });
        }
        return foundPermission;
    }
}
